import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { ProductListModule } from './productlist.module';
platformBrowserDynamic().bootstrapModule(ProductListModule);
